var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 } from 'uuid';
import { debouncePromise } from '../utils';
import BaseWithPoling from './baseWithPolingApi';
export default class AdministrationApi extends BaseWithPoling {
    constructor(apiCall, batchProcessApi) {
        super(apiCall, batchProcessApi);
        this.apiCall = apiCall;
        this.batchProcessApi = batchProcessApi;
        this.apiBasePath = 'admin';
    }
    getIndicesStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/status`,
            });
        });
    }
    isSystemBusy() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/busy`,
            });
        });
    }
    addIndex(dbIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const batchId = v4();
            this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/index`,
                data: {
                    batchId,
                    index: dbIndex,
                },
            });
            try {
                yield debouncePromise(() => this.polling(batchId), 3000);
                return true;
            }
            catch (_) {
            }
            return false;
        });
    }
    dropIndex(dbIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const batchId = v4();
            this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}/index`,
                data: {
                    batchId,
                    index: dbIndex,
                },
            });
            try {
                yield debouncePromise(() => this.polling(batchId), 3000);
                return true;
            }
            catch (_) {
            }
            return false;
        });
    }
    getCountInTable(tableName) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/count/${tableName}`,
            });
        });
    }
    reportDbSizes() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/db-size`,
            });
        });
    }
}
//# sourceMappingURL=administrationApi.js.map